export default __webpack_public_path__ + "static/media/heavenLogo.5d4d0a0d.png";